import React, { createContext, useContext } from 'react'

import PromoPricingInfo from '../models/promoPricingInfo'
import native from '../native/native'
import { useAppState } from './appStateContext'

interface State {
  pricing: PromoPricingInfo
}

interface Actions {
  subscribe: () => void
}

interface Context {
  state: State
  actions: Actions
}

const PromoContext = createContext<Context | null>(null)

const PromoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const productData = useAppState().state.productData!
  const promoProduct = productData.products.find((product) => {
    return product.introPricing?.period == 365
  })!
  const yearlyProduct = productData.premium.yearlyProduct

  const subscribe = () => {
    native.subscribe(promoProduct)
  }

  const state: State = {
    pricing: PromoPricingInfo.fromYearlyProducts(promoProduct, yearlyProduct),
  }
  const actions = { subscribe }

  return <PromoContext.Provider value={{ state, actions }}>{children}</PromoContext.Provider>
}

const usePromo = () => {
  const context = useContext(PromoContext)

  if (!context) {
    throw new Error("usePromo has to be used within <PromoContext.Provider>")
  }

  return context
}

export { PromoProvider, PromoContext, usePromo }
